<template>
  <div class="analysisHead">
    <el-select
      v-model="timeType"
      placeholder="请选择"
      :popper-append-to-body="false"
      size="small"
      style="width: 10%; margin: 0 20px 0 20px"
      @change="getDataValue"
    >
      <el-option label="月" value="MONTH"> </el-option>
      <el-option label="年" value="YEAR"> </el-option>
      <el-option label="全部" value="UNLIMITED"> </el-option>
    </el-select>
    <template v-if="timeType !== 'UNLIMITED'">
      <el-date-picker
        size="small"
        style="margin-right: 20px"
        v-model="timeValue"
        :clearable="false"
        :type="timeType == 'YEAR' ? 'year' : 'month'"
        :key="timeType == 'YEAR' ? 'year' : 'month'"
        :placeholder="timeType == 'YEAR' ? '选择年' : '选择月'"
        :value-format="timeType == 'YEAR' ? 'yyyy' : 'yyyy-MM'"
        :picker-options="
          timeType == 'MONTH' && $route.path == '/devOpsReport'
            ? pickerOptions
            : pickerOptions1
        "
      >
      </el-date-picker>
    </template>
    <el-button type="primary" size="mini" @click="submit">查询</el-button>
    <el-button
      type="primary"
      @click="$parent.exportWord()"
      size="mini"
      v-if="$route.path == '/devOpsReport' && showDownload"
      ><i class="el-icon-download el-icon--left"></i>WORD</el-button
    >
  </div>
</template>

<script>
import { dateFtt } from "@/assets/js/utils";
export default {
  props: {
    showDownload: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      timeType: "MONTH",
      timeValue: null,
      pickerOptions: {
        disabledDate(time) {
          let t = new Date().getDate();
          return time.getTime() > Date.now() - 8.64e7 * t;
        },
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
    };
  },
  methods: {
    getDataValue() {
      if (this.timeType == "YEAR") {
        this.timeValue = dateFtt("yyyy", new Date());
      } else if (this.timeType == "MONTH") {
        if (this.$route.path == "/devOpsReport") {
          this.timeValue = this.$moment(new Date())
            .subtract("1", "M")
            .format("YYYY-MM");
        } else {
          this.timeValue = dateFtt("yyyy-MM", new Date());
        }
      } else {
        this.timeValue = null;
      }
    },
    submit() {
      this.$emit("getActiveTime", {
        type: this.timeType,
        timeValue: this.timeValue,
        key:
          this.timeType == "MONTH"
            ? "day"
            : this.timeType == "YEAR"
            ? "month"
            : "year",
      });
    },
  },
  created() {
    this.getDataValue();
    this.submit();
  },
};
</script>

<style lang="scss" scoped>
.analysisHead {
  height: 60px;
  width: $innerWidth;
  margin: 16px auto 12px;
  background: #fff;
  @include setFlexStart;
}
</style>
